// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_filter_value_transparent1 = /** @type {(inputs: {}) => string} */ () => {
	return `Transparent`
};

const el_filter_value_transparent1 = /** @type {(inputs: {}) => string} */ () => {
	return `Διάφανο`
};

const ru_filter_value_transparent1 = /** @type {(inputs: {}) => string} */ () => {
	return `Прозрачная`
};

const he_filter_value_transparent1 = /** @type {(inputs: {}) => string} */ () => {
	return `שקופה`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const filter_value_transparent1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.filter_value_transparent1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("filter_value_transparent1", locale)
	if (locale === "en") return en_filter_value_transparent1(inputs)
	if (locale === "el") return el_filter_value_transparent1(inputs)
	if (locale === "ru") return ru_filter_value_transparent1(inputs)
	if (locale === "he") return he_filter_value_transparent1(inputs)
	return "filter_value_Transparent"
};
export { filter_value_transparent1 as "filter_value_Transparent" }